// @flow
export const STUDENT_INFO_FORM: string = "studentInfoForm";
export const EDIT: string = "EDIT";
export const NOTE: string = "NOTE";
export const NO_MODE: string = "NONE";
